export const PAGE_URL = {
  // PUBLIC PART
  MAIN: '/',
  MAIN_LANDING_PAGE: '/main',
  // MY_SPACE: '/my-space',

  // AUTHENTICATION PART
  AUTH: '/auth',
  AUTH_VERIFY_EMAIL: '/auth/verify-email',
  AUTH_PERSONAL_INFO: '/auth/personal-info',
  AUTH_FORGOT_PASSWORD: '/auth/forgot-password',
  AUTH_RESET_PASSWORD: '/auth/reset-password',
  AUTH_PASSWORD_CHANGED: '/auth/password-changed',
  AUTH_SECURITY: '/auth/security',
  AUTH_SECURITY_CHANGE_PASSWORD: '/security/change-password',
  AUTH_SECURITY_DELETE_ACCOUNT: '/security/delete-account',
  AUTH_SECURITY_CHANGE_PASSWORD_SUCCESS: '/security/change-password-success',
  AUTH_CHANGE_PASSWORD: '/auth/change-password', // Deprecated - use AUTH_SECURITY_CHANGE_PASSWORD
  AUTH_ACCOUNT_SET_PASSWORD: '/account/set-password',
  AUTH_ACCOUNT_CHANGE_PASSWORD: '/account/change-password',
  AUTH_ACCOUNT_DELETE: '/account/delete-account',
  SIGN_IN: '/signin',
  SIGN_UP: '/signup',
  // VERIFY_EMAIL: '/verify-email',

  // SEARCH PART
  SEARCH_RESULTS: '/conversation/:conversation_strid?/:chat_strid?',
  // NEW_RESULT: '/new-result',

  // SUMMARY PART
  SUMMARY: '/summary',
  SUMMARY_WITH_ID: '/summary/:conversation_strid?',

  // CHAT PDF PART
  CHAT_PDF: '/conversation/:conversation_strid/chat-pdf/:chat_strid?',

  // APPLICATION PART
  // APPLICATION: '/application',

  // TRANSLATOR PART
  // TRANSLATOR: '/translator',

  // PLAN SELECTION PART
  PLAN_SELECTION: '/choose-your-plan',

  // EMAIL DRAFTER PART
  // EMAIL_DRAFTER_OPTIONAL_ID: '/email-drafter/:conversation_strid?',
  // DRAFTER_WITH_ID: '/drafter/:conversation_strid',
  // DRAFTER: '/drafter',
  DOC_MANAGEMENT: '/documents',
  DOC_MANAGEMENT_FOLDER: '/documents/folder/:folder_strid',

  // WORKSPACE PART

  WORKSPACE: '/s/workspace/:workspace_strid',
  WORKSPACE_DOCUMENT_MANAGEMENT: '/s/workspace/:workspace_strid/documents',
  WORKSPACE_DOCUMENT_MANAGEMENT_FOLDER:
    '/s/workspace/:workspace_strid/documents/folder/:folder_strid',
  WORKSPACE_DOC_MANAGEMENT: '/s/workspace/:workspace_strid/doc-management',
  WORKSPACE_DOC_MANAGEMENT_WITH_ID:
    '/s/workspace/:workspace_strid/doc-management/:document_strid',
  // WORKSPACE_MY_SPACE: '/workspace/:workspace_strid/my-space',
  WORKSPACE_SEARCH_RESULTS:
    '/s/workspace/:workspace_strid/conversation/:conversation_strid?/:chat_strid?',
  // WORKSPACE_NEW_RESULT: '/workspace/:workspace_strid/new-result',
  WORKSPACE_SUMMARY: '/s/workspace/:workspace_strid/summary',
  WORKSPACE_SUMMARY_WITH_ID:
    '/s/workspace/:workspace_strid/summary/:conversation_strid?',
  WORKSPACE_CHAT_PDF:
    '/s/workspace/:workspace_strid/conversation/:conversation_strid/chat-pdf/:chat_strid?',
  WORKSPACE_APPLICATION: '/s/workspace/:workspace_strid/application',
  WORKSPACE_PLAN_SELECTION: '/workspace/:workspace_strid/choose-your-plan',
  // WORKSPACE_TRANSLATOR: '/workspace/:workspace_strid/translator',
  // WORKSPACE_EMAIL_DRAFTER: '/workspace/:workspace_strid/email-drafter/:conversation_strid?',
  // WORKSPACE_DRAFTER: '/workspace/:workspace_strid/drafter',
  // WORKSPACE_DRAFTER_WITH_ID: '/workspace/:workspace_strid/drafter/:conversation_strid',

  // ADVANCE SEARCH PART
  ADVANCED_SEARCH: '/advanced-search',
  AUTO_SEARCH_RESULTS: '/auto-search/results',
  AUTO_SEARCH_QUERY_GROUPS: '/auto-search/query-groups',
  ADVANCED_SEARCH_RESULT: '/advanced-search/result',
  WORKSPACE_ADVANCED_SEARCH: '/workspace/:workspace_strid/advanced-search',
  WORKSPACE_ADVANCED_SEARCH_RESULT:
    '/workspace/:workspace_strid/advanced-search/result',

  // IND project part
  IND_PROJECTS: '/workspace/ind',
  IND_WORKSPACE: '/workspace/ind/:workspace_strid',
  IND_RESULT: '/workspace/ind/:workspace_strid/:section_strid',
  // IND_WORKSPACE: '/workspace/:workspace_strid/ind',
  // IND_RESULT: '/workspace/:workspace_strid/ind/:ind_strid',

  // CSR Project
  CSR_PROJECTS: '/workspace/csr',
  CSR_WORKSPACE: '/workspace/csr/:workspace_strid',
  // CSR_WORKSPACE: '/workspace/:workspace_strid/csr',

  // // CHERION Search Projects
  // CHERION_SEARCH_PROJECTS: '/workspace',
  // CHERION_SEARCH_PROJECTS_WITH_ID: '/workspace/:workspace_strid',

  //Temp route for enterprise layout
  ENTERPRISE_PROJECTS: '/enterprise-projects',
  // IND EnterPrise
  IND_MY_DRAFT: '/workspace/ind/my-draft',
  IND_DOCUMENTS: '/workspace/ind/:workspace_strid/documents',
  IND_DOCUMENTS_WITH_SECTION:
    '/workspace/ind/:workspace_strid/:section_strid/documents',
  IND_DOCUMENTS_FOLDER:
    '/workspace/ind/:workspace_strid/documents/folder/:strid',
  IND_DOCUMENTS_FOLDER_WITH_SECTION:
    '/workspace/ind/:workspace_strid/:section_strid/documents/folder/:strid',

  // CSR Enterprise
  CSR_MY_DRAFT: '/workspace/csr/my-draft',
  CSR_DOCUMENTS: '/workspace/csr/:workspace_strid/documents',
  CSR_DOCUMENTS_FOLDER:
    '/workspace/csr/:workspace_strid/documents/folder/:strid',

  // Terms and Conditions and Privacy Policy
  TERMS_AND_CONDITIONS: '/policies/terms-of-use/:lang?',
  PRIVACY_POLICY: '/policies/privacy-policy/:lang?',

  // Setting
  SETTINGS: '/settings',
  SETTINGS_PROFILE: '/settings/profile',
  SETTINGS_LANGUAGE: '/settings/language',

  NOT_FOUND: '*',

  // CHEIRON SEARCH/WRITE
  CHEIRON_SEARCH: '/s',
  CHEIRON_WRITE: '/w',

  // Admin DashBoard
  ADMIN_DASHBOARD: '/admin-dashboard',

  // CHEIRON WRITE
  CHEIRON_WRITE_PROJECTS: '/w/workspace',
  CHEIRON_WRITE_CSR_DOCUMENTS: '/w/workspace/csr/:workspace_strid/documents',
  CHEIRON_WRITE_CSR_DOCUMENTS_FOLDER:
    '/w/workspace/csr/:workspace_strid/documents/folder/:folder_strid',
  CHEIRON_WRITE_IND_DOCUMENTS: '/w/workspace/ind/:workspace_strid/documents',
  CHEIRON_WRITE_IND_DOCUMENTS_WITH_SECTION:
    '/w/workspace/ind/:workspace_strid/:section_strid/documents',
  CHEIRON_WRITE_IND_DOCUMENTS_FOLDER:
    '/w/workspace/ind/:workspace_strid/documents/folder/:folder_strid',
  CHEIRON_WRITE_IND_DOCUMENTS_FOLDER_WITH_SECTION:
    '/w/workspace/ind/:workspace_strid/:section_strid/documents/folder/:folder_strid',
  CHEIRON_WRITE_CSR_DRAFT:
    '/w/workspace/csr/:workspace_strid/draft/:draft_strid',
  CHEIRON_WRITE_IND_DRAFT: '/w/workspace/ind/:workspace_strid',
  CHEIRON_WRITE_IND_DRAFT_WITH_ID:
    '/w/workspace/ind/:workspace_strid/:section_strid',

  // CHEIRON SEARCH
  CHEIRON_SEARCH_PROJECTS: '/s/workspace',
  CHEIRON_SEARCH_DOCUMENTS: '/s/workspace/:workspace_strid/documents',
  CHEIRON_SEARCH_DOCUMENTS_FOLDER:
    '/s/workspace/:workspace_strid/documents/folder/:strid',
  CHEIRON_SEARCH_RESULTS:
    '/s/workspace/:workspace_strid/conversation/:conversation_strid?',
  CHEIRON_SEARCH_SUMMARY: '/s/workspace/:workspace_strid/summary',
  CHEIRON_SEARCH_SUMMARY_WITH_ID:
    '/s/workspace/:workspace_strid/summary/:conversation_strid',
  CHEIRON_SEARCH_ADVANCED_SEARCH:
    '/s/workspace/:workspace_strid/advanced-search',
  CHEIRON_SEARCH_ADVANCED_SEARCH_RESULT:
    '/s/workspace/:workspace_strid/advanced-search/result',
  CHEIRON_SEARCH_AUTO_SEARCH_RESULTS:
    '/s/workspace/:workspace_strid/auto-search/results',
  CHEIRON_SEARCH_AUTO_SEARCH_QUERY_GROUPS:
    '/s/workspace/:workspace_strid/auto-search/query-groups',
  CHEIRON_SEARCH_CHAT_PDF:
    '/s/workspace/:workspace_strid/conversation/:conversation_strid/chat-pdf/:chat_strid?',
  CHEIRON_SEARCH_MAIN: '/s',
  CHEIRON_SEARCH_MAIN_WITH_ID: '/s/workspace/:workspace_strid',
  CHEIRON_SEARCH_CONVERSATION:
    '/s/workspace/:workspace_strid/conversation/:conversation_strid?',
}
